import { Identifiable, ProjectResource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  resource: Identifiable<ProjectResource>,
  {
    nextProjectResource,
    projectResource: r,
  }: Boundaries["editProjectResource"]["request"],
): Identifiable<ProjectResource> {
  return r.uuid === resource.uuid
    ? { ...resource, ...nextProjectResource }
    : resource;
}

function handleEditSuccess(
  resource: Identifiable<ProjectResource>,
  projectResource: Boundaries["editProjectResource"]["success"],
): Identifiable<ProjectResource> {
  return projectResource.uuid === resource.uuid ? projectResource : resource;
}

function handleEditFailure(
  resource: Identifiable<ProjectResource>,
  { projectResource: r }: Boundaries["editProjectResource"]["failure"],
): Identifiable<ProjectResource> {
  return r.uuid === resource.uuid ? r : resource;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
